import React, { useState, useEffect, useRef } from "react";
import ReportsDiamondService from "../../../services/reports-Diamond.service";
import { Pie, getElementAtEvent } from "react-chartjs-2";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ReportJewelryReportService from "../../../services/reports-Jewelry-service";
import moment from "moment";
import DefaultImage from "../../../assets/images/icons/sampleimage.jpg";
import { BlobToDownloadFile } from "../../../helper/commanFunction";
import { Button, DatePicker, Modal, Select, Spin, Table, Tooltip } from "antd";
import Chart from "react-google-charts";

const { RangePicker } = DatePicker;
const { Option } = Select;

const initialEventState = {
  dealerID: "",
  forDealer: "",
  fromDate: moment().subtract(30, "days"),
  toDate: moment(),
  SelectedDiamondValue: "All",
  price: "",
  price1: "",
  price2: "",
};

const DiamondPriceBasedAddToCartReports = () => {
  const { t } = useTranslation();
  const JewelPriceChartRef = useRef();

  const [dealerId, setDealerId] = useState();
  const loginDetials = useSelector((state) => state.loginReducer);
  const [selectedData, setSelectedData] = useState(initialEventState);
  const [isApplyFilter, setIsApplyFilter] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [showTableLoader, setShowTableLoader] = useState(false);
  const [JewelryPriceTableList, setJewelryPriceTableList] = useState([]);
  const [visible, setVisible] = useState(false);
  const [defaultVisible, setDefaultVisible] = useState(false);
  const [showChart, setShowChart] = useState(false);
  const [totalValueForPercentage, setTotalValueForPercentage] = useState(0);
  const [priceRange, setPriceRange] = useState([]);
  const [topPriceTotal, setPriceTotal] = useState([]);
  const [TooltipPercentage, setTooltipPercentage] = useState("");
  const [key, setKey] = useState(true);
  const [sortColumnName, setSortColumnName] = useState("AK.Date");
  const [sortType, setSortType] = useState("desc");
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [TotalDiamondClicks, setTotalDiamondClicks] = useState(0);
  const [downloadCSVDataloading, setDownloadCSVDataloading] = useState(false);

  // New state for custom legends and max entries
  const [chartData, setChartData] = useState([]);
  const [colorData, setColorData] = useState([]);
  const [processedPriceRange, setProcessedPriceRange] = useState([]);
  const [processedPriceTotal, setProcessedPriceTotal] = useState([]);

  // Configuration
  const MAX_ENTRIES = 10; // Maximum slices to show
  const chartColors = [
    "#0EDCE8", "#109618", "#FF9900", "#990099", "#0099C6",
    "#3366CC", "#DC3912", "#66AA00", "#DD4477", "#EDED01",
    "#B82E2E", "#316395", "#994499", "#22AA99", "#AAAA11",
    "#6633CC", "#E67300", "#8B0707", "#329262", "#3B3EAC"
  ];

  // Process chart data with max entries limit
  const processChartData = (ranges, totals) => {
    if (!ranges?.length || !totals?.length || ranges.length !== totals.length) {
      return { chartData: [], colors: [], processedRanges: [], processedTotals: [] };
    }

    // Combine ranges and totals into objects
    const combinedData = ranges.map((range, index) => ({
      range,
      total: totals[index],
      originalIndex: index
    }));

    // Filter out zero values and sort by total (descending)
    const filteredData = combinedData.filter(item => item.total > 0);
    const sortedData = [...filteredData].sort((a, b) => b.total - a.total);

    // Apply max entries limit
    const topData = sortedData.slice(0, MAX_ENTRIES);
    const remainingData = sortedData.slice(MAX_ENTRIES);

    // Calculate "Others" if needed
    const othersValue = remainingData.reduce((sum, item) => sum + item.total, 0);
    if (othersValue > 0 && remainingData.length > 0) {
      topData.push({
        range: t("Others"),
        total: othersValue,
        isOthers: true
      });
    }

    // Calculate total for percentages
    const total = topData.reduce((sum, item) => sum + item.total, 0);

    // Prepare chart data
    const processedChartData = [["Price Range", "Total"]];
    const colors = [];
    const processedRanges = [];
    const processedTotals = [];

    topData.forEach((item, index) => {
      const percentage = total > 0 ? ((item.total / total) * 100).toFixed(2) : 0;
      const color = chartColors[index % chartColors.length];
      colors.push(color);
      
      // For Google Charts with percentage in label
      processedChartData.push([`${item.range} (${percentage}%)`, item.total]);
      
      // Store processed data for other uses
      processedRanges.push(item.range);
      processedTotals.push(item.total);
    });

    return { 
      chartData: processedChartData, 
      colors, 
      processedRanges, 
      processedTotals 
    };
  };

  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          setDealerId(loginDetials.loginDetials.responseData.dealerId);
          handleGetForDealer(loginDetials.loginDetials.responseData.dealerId);
        }
      }
    }
  }, []);

  useEffect(() => {
    if (selectedData.price1)
      handleGetTableChartData(dealerId, selectedData.forDealer);
  }, [selectedData]);

  const handleGetForDealer = (id) => {
    try {
      const initialEventState = {
        dealerID: id,
      };
      setShowLoader(true);
      ReportJewelryReportService.GetForDealer(initialEventState).then(
        (response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;

          // Calculate forDealer based on dealerMemberTypeName
          let forDealer;
          if (
            loginDetials.loginDetials.responseData.dealerMemberTypeName ===
              "VendorDiamond" ||
            loginDetials.loginDetials.responseData.dealerMemberTypeName ===
              "VendorGemstone" ||
            loginDetials.loginDetials.responseData.dealerMemberTypeName === "Vendor"
          ) {
            forDealer = 1;
          } else if (
            loginDetials.loginDetials.responseData.dealerMemberTypeName ===
              "Retailer" ||
            loginDetials.loginDetials.responseData.dealerMemberTypeName === "Combined"
          ) {
            forDealer = 2;
          } else {
            forDealer = 3;
          }

          if (message === "Success") {
            setSelectedData((prevState) => ({
              ...prevState,
              forDealer: forDealer,
            }));

            handleGetPriceColumnData(id, forDealer);
            handleGetTableChartData(
              id,
              forDealer,
              pageNo,
              pageSize,
              sortColumnName,
              sortType,
              "Empty_Price"
            );
          }
        }
      );
    } catch (error) {
      console.log(error);
    }
  };

  const handleGetPriceColumnData = (DealerId, forDealerId) => {
    if (
      loginDetials.loginDetials.responseData.dealerMemberTypeName ===
        "VendorDiamond" ||
      loginDetials.loginDetials.responseData.dealerMemberTypeName ===
        "VendorGemstone"
    ) {
      forDealerId = 1;
    }
    try {
      const initialEventState = {
        dealerID: DealerId.toString(),
        forDealer: forDealerId.toString(),
        fromDate: selectedData.fromDate
          ? moment(selectedData.fromDate).format("YYYY-MM-DD")
          : "2016-03-07",
        toDate: selectedData.toDate
          ? moment(selectedData.toDate).format("YYYY-MM-DD")
          : "2023-04-06",
        selectedDiamondValue: selectedData.SelectedDiamondValue
          ? selectedData.SelectedDiamondValue.toString()
          : "All",
        addToType: "AddToCart",
      };
      setShowLoader(true);
      ReportsDiamondService.AddToCartOrWishlistChartColunmData(
        initialEventState
      ).then((response) => {
        let message = response.data.message;
        let responseData = response.data.responseData.PriceBasedData;

        if (message === "Success") {
          let priceRange = [];
          let total = [];
          let showResp = responseData.every((element) => {
            return element.TOTAL == "0";
          });
          setShowChart(showResp);
          for (let i of responseData) {
            if (i.TOTAL !== 0) {
              priceRange.push(i.Range);
              total.push(i.TOTAL);
            }
          }

          var JewelVendorYAxisList = responseData.map((item) => {
            return parseInt(item.TOTAL);
          });
          var totalValueForPercentage = JewelVendorYAxisList.reduce(
            (a, b) => a + b,
            0
          );
          setTotalDiamondClicks(
            response.data.responseData.TotalDiamondClicks[0].TotalClickCnt
          );
          setTotalValueForPercentage(totalValueForPercentage);
          
          // Process data with max entries limit
          const { 
            chartData: processedChartData, 
            colors, 
            processedRanges, 
            processedTotals 
          } = processChartData(priceRange, total);
          
          setChartData(processedChartData);
          setColorData(colors);
          setProcessedPriceRange(processedRanges);
          setProcessedPriceTotal(processedTotals);
          
          setPriceTotal(total);
          setPriceRange(priceRange);
          setShowLoader(false);
          setKey(!key);
        } else {
          setShowLoader(false);
        }
      });
    } catch (error) {
      console.log(error);
      setShowLoader(false);
    }
  };

  const [totalCount, setTotalCount] = useState(0);

  const handleExportToCSV = (sortColumn, sorttype) => {
    try {
      let inputData = {
        dealerID: selectedData.dealerID.toString(),
        forDealer: "1",
        fromDate: selectedData.fromDate
          ? moment(selectedData.fromDate).format("YYYY-MM-DD")
          : "2016-03-07",
        toDate: selectedData.toDate
          ? moment(selectedData.toDate).format("YYYY-MM-DD")
          : "2023-04-06",
        clarity: "",
        cutGrade: "",
        shape: "",
        color: "",
        size: "",
        certificate: "",
        selectedDiamondValue: selectedData.SelectedDiamondValue
          ? selectedData.SelectedDiamondValue.toString()
          : "All",
        pageNumber: pageNo,
        pageSize: pageSize,
        sortOrderCol: sortColumnName ? sortColumnName : sortColumnName,
        sortOrderType: sortType,
        addToType: "AddToCart",
        price: selectedData.price,
        price1: selectedData.price1?.trim().toString() || "",
        price2: selectedData.price2?.trim().toString() || "",
        vendorIds: "",
      };
      setDownloadCSVDataloading(true);
      ReportsDiamondService.ExportDataToCSV(inputData)
        .then((response) => {
          setDownloadCSVDataloading(false);
          var fileName =
            loginDetials.loginDetials.responseData.dealerCompany.replace(/\s+/g, "") +
            "_DiamondPrice_Report_" +
            new Date().toJSON().slice(0, 10).split("-").slice(1).concat(new Date().toJSON().slice(0, 4)).join("_") +
            ".csv";
          BlobToDownloadFile(response.data, fileName);
        })
        .catch((error) => {
          setDownloadCSVDataloading(false);
        });
    } catch (error) {
      console.log(error);
      setDownloadCSVDataloading(false);
    }
  };

  // For Chart Data
  const handleGetTableChartData = (
    DealerId,
    forDealerId,
    pageNumber,
    pageSiz,
    sortColumnName,
    sortOrder,
    priceValueEmpty
  ) => {
    try {
      if (
        loginDetials.loginDetials.responseData.dealerMemberTypeName ===
          "VendorDiamond" ||
        loginDetials.loginDetials.responseData.dealerMemberTypeName ===
          "VendorGemstone"
      ) {
        forDealerId = 1;
      }
      let inputData = {
        dealerID: DealerId.toString(),
        forDealer: forDealerId ? forDealerId.toString() : "",
        fromDate: selectedData.fromDate
          ? moment(selectedData.fromDate).format("YYYY-MM-DD")
          : "2016-03-07",
        toDate: selectedData.toDate
          ? moment(selectedData.toDate).format("YYYY-MM-DD")
          : "2023-04-06",
        clarity: "",
        cutGrade: "",
        shape: "",
        color: "",
        size: "",
        certificate: "",
        selectedDiamondValue: selectedData.SelectedDiamondValue
          ? selectedData.SelectedDiamondValue.toString()
          : "All",
        pageNumber: pageNumber ? pageNumber : pageNo,
        pageSize: pageSiz ? pageSiz : pageSize,
        sortOrderCol: sortColumnName ? sortColumnName : sortColumnName,
        sortOrderType: sortOrder ? sortOrder : sortType,
        addToType: "AddToCart",
        price: priceValueEmpty ? "" : selectedData.price,
        price1: priceValueEmpty ? "" : selectedData.price1?.trim().toString() || "",
        price2: priceValueEmpty ? "" : selectedData.price2?.trim().toString() || "",
        vendorIds: "",
      };

      setShowTableLoader(true);
      ReportsDiamondService.AddToCartOrWishlistReportForTableChart(inputData)
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData.tableChartList;
          if (message === "Success") {
            setTotalCount(response?.data?.responseData?.totalCount || 0);
            setJewelryPriceTableList(responseData);
            setShowTableLoader(false);
          } else {
            setTotalCount(0);
            setJewelryPriceTableList([]);
            setShowTableLoader(false);
          }
        })
        .catch((error) => {
          setTotalCount(0);
          setShowTableLoader(false);
          console.log(error);
        });
    } catch (error) {
      setTotalCount(0);
      console.log(error);
      setShowTableLoader(false);
    }
  };

  const handleApplyFilter = () => {
    setSelectedData((prevState) => ({
      ...prevState,
      price: "",
      price1: "",
      price2: "",
    }));
    handleGetForDealer(dealerId);
    setIsApplyFilter(!isApplyFilter);
  };

  const onDateChange = (dates, dateStrings) => {
    if (dates) {
      setSelectedData((prevState) => ({
        ...prevState,
        fromDate: moment.utc(dates[0]).toISOString(),
        toDate: moment.utc(dates[1]).toISOString(),
      }));
    }
  };

  const handleOnChange = (e, isSelect, name) => {
    setSelectedData({
      ...selectedData,
      [name]: e,
    });
  };

  const handleTableASCDES = (pagination, filters, sorter) => {
    var tableBody = document.querySelector(".pendjewelreq__tbl .ant-table-body"); if (tableBody) tableBody.scrollTop = 0;
    var type = "";
    var column = "";
    //sorting
    if (sorter.order == "descend") {
      type = "DESC";
      column = sorter.field;
      setSortType(type);
      setSortColumnName(column);
    } else if (sorter.order == "ascend") {
      type = "ASC";
      column = sorter.field;
      setSortType(type);
      setSortColumnName(column);
    } else {
      type = "DESC";
      column = "dealerId";
      setSortColumnName(column);
      setSortType(type);
    }

    setPageNo(pagination.current);
    setPageSize(pagination.pageSize);

    handleGetTableChartData(
      dealerId,
      selectedData.forDealer,
      pagination.current,
      pagination.pageSize,
      column,
      type
    );
  };

  const chartOptions = {
    pieSliceText: "percentage",
    tooltip: { trigger: "selection" },
    legend: { position: "none" }, // Remove default legend since we have custom one
    pieStartAngle: 100,
    slices: colorData.reduce((acc, color, index) => {
      acc[index] = { color };
      return acc;
    }, {}),
    chartArea: { width: "80%", height: "80%" },
  };

  const handleSelect = ({ chartWrapper }) => {
    const chart = chartWrapper.getChart();
    const selection = chart.getSelection();

    if (!selection.length) return;

    const index = selection[0].row;
    const range = processedPriceRange[index];
    
    // Handle the case where "Others" is selected
    if (range === t("Others")) {
      // You might want to handle "Others" selection differently
      // For now, let's clear the price filters when "Others" is selected
      setSelectedData({
        price: "",
        price1: "",
        price2: "",
      });
      return;
    }

    const price1 =
      range === "Call for Price"
        ? ""
        : range.includes("Under")
        ? "0"
        : range.split("-")[0].split("$")[1];

    const price2 =
      range === "Call for Price"
        ? ""
        : range.includes("Under")
        ? range.split("$")[1]
        : range.split("-").length > 1
        ? range.split("-")[1].split("$")[1]
        : range;

    setSelectedData({
      price: range === "Call for Price" ? "Call for Price" : "",
      price1,
      price2,
    });
  };

  return (
    <React.Fragment>
      <div className="pendjewelreq__section">
        <div className="form__fields">
          <div className="row magento__mapping">
            <div className="col-md-12">
              <div className="heading__block">
                <h4 class="workarea__heading mt-0 mb-0">
                  {t("Diamond Price Based Add To Cart Report")}
                </h4>
              </div>
            </div>
            <div className="col-md-4">
              <div className="input__block datepicker__block">
                <label> {t("Date Range")} </label>
                <RangePicker
                  className="date-range-input"
                  ranges={{
                    Today: [moment(), moment()],
                    Yesterday: [
                      moment().subtract(1, "days"),
                      moment().subtract(1, "days"),
                    ],
                    "Last 7 Days": [moment().subtract(7, "days"), moment()],
                    "Last 30 Days": [moment().subtract(30, "days"), moment()],
                    "This Month": [
                      moment().startOf("month"),
                      moment().endOf("month"),
                    ],
                    "Last Month": [
                      moment().subtract(1, "month").startOf("month"),
                      moment().subtract(1, "months").endOf("month"),
                    ],
                    "Last 90 Days": [moment().subtract(90, "days"), moment()],
                    "Year To Date": [moment().startOf("year"), moment()],
                  }}
                  format={"MM-DD-YYYY"}
                  onChange={onDateChange}
                  defaultValue={[moment().subtract(30, "days"), moment()]}
                  defaultPickerValue={[moment().subtract(30, "days"), moment()]}
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="input__block">
                <label> {t("Select Diamond")} </label>
                <Select
                  className="border__grey"
                  placeholder={t("All")}
                  showSearch
                  name="SelectedDiamondValue"
                  optionFilterProp="children"
                  value={
                    selectedData.SelectedDiamondValue
                      ? selectedData.SelectedDiamondValue
                      : null
                  }
                  onChange={(e) =>
                    handleOnChange(e, "select", "SelectedDiamondValue")
                  }
                >
                  <Option value="All">{t("All")}</Option>
                  <Option value="Mined">{t("Mined Diamond")}</Option>
                  <Option value="Lab">{t("Lab Grown Diamond")}</Option>
                </Select>
              </div>
            </div>
            <div className="col-lg-12 col-md-6">
              <div className="input__block">
                <label>
                  <Spin spinning={showLoader} size="small">
                    <b>
                      {t("Total Clicks")} :{" "}
                      {TotalDiamondClicks ? TotalDiamondClicks : 0}
                    </b>
                  </Spin>
                </label>
              </div>
            </div>
            <div className="col-md-12 mt-2">
              <div className="button__block mb-4">
                <button
                  className="primary-btn mt-2"
                  onClick={handleApplyFilter}
                >
                  {t("Apply Filter")}
                </button>
              </div>
            </div>
            {!showChart ? (
              <Spin spinning={showLoader}>
                <div className="col-lg-12">
                  <div className="chart__section">
                    {chartData.length > 1 && JewelryPriceTableList && JewelryPriceTableList.length > 0 && (
                      <div className="pdf-content">
                        {/* Custom Legend */}
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            justifyContent: "center",
                            marginBottom: "10px",
                            gap: "8px",
                          }}
                        >
                          {chartData.slice(1).map((row, index) => (
                            <div
                              key={index}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                margin: "2px 4px",
                                fontSize: "12px",
                                fontWeight: "500",
                                padding: "2px 6px",
                                backgroundColor: "#f5f5f5",
                                borderRadius: "4px",
                              }}
                            >
                              <div
                                style={{
                                  width: "12px",
                                  height: "12px",
                                  backgroundColor: colorData[index],
                                  marginRight: "6px",
                                  borderRadius: "2px",
                                }}
                              ></div>
                              {row[0].replace(/\s*\([^)]*\)\s*/g, "")} ({row[1]})
                            </div>
                          ))}
                        </div>

                        {/* Chart */}
                        <Chart
                          chartType="PieChart"
                          width="100%"
                          height="300px"
                          data={chartData}
                          options={chartOptions}
                          chartEvents={[
                            {
                              eventName: "select",
                              callback: handleSelect,
                            },
                          ]}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </Spin>
            ) : (
              <Spin spinning={showLoader}>
                <div className="no-report-render">
                  <div className="desc-space">
                    <h4 className="text-center">{t("No Data Found")}</h4>
                  </div>
                </div>
              </Spin>
            )}
            
            <div className="col-lg-12 mt-3">
              <div className="options__div">
                <div className="row mb-4">
                  <div className="col-lg-10 rules__div"></div>
                  <div className="col-lg-12 mt-3 d-flex flex-column flex-lg-row justify-content-lg-end mb-3">
                    <Button
                      className="primary-btn mb-2 mb-lg-0 mr-2"
                      onClick={() => handleExportToCSV()}
                      loading={downloadCSVDataloading}
                    >
                      {" "}
                      <i className="fa fa-download"></i> {t("Download CSV")}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-12 col-md-12 mt-4">
              <div className="table__scroll">
                <Table
                  className="pendjewelreq__tbl"
                scroll={{ x: 1200, y: "calc(100vh - 340px)" }}
                  columns={[
                    {
                      title: (
                        <Tooltip title={t("UserIPAddress")}>
                          {t("UserIPAddress")}
                        </Tooltip>
                      ),
                      ellipsis: true,
                      dataIndex: "usersIPAddress",
                      sorter: (a, b) => {},
                    },
                    {
                      title: <Tooltip title={t("Date")}>{t("Date")}</Tooltip>,
                      ellipsis: true,
                      defaultSortOrder: "descend",
                      sorter: (a, b) => {},
                      dataIndex: "date",
                      render: (item, row) => {
                        return moment(row.date).format(
                          "MM-DD-YYYY, hh:mm:ss A"
                        );
                      },
                    },
                    {
                      title: <Tooltip title={t("Shape")}>{t("Shape")}</Tooltip>,
                      ellipsis: true,
                      dataIndex: "shape",
                      sorter: (a, b) => {},
                    },
                    {
                      title: <Tooltip title={t("Size")}>{t("Size")}</Tooltip>,
                      ellipsis: true,
                      dataIndex: "size",
                      sorter: (a, b) => {},
                    },
                    {
                      title: <Tooltip title={t("Color")}>{t("Color")}</Tooltip>,
                      ellipsis: true,
                      dataIndex: "color",
                      sorter: (a, b) => {},
                    },
                    {
                      title: <Tooltip title={t("Cut")}>{t("Cut")}</Tooltip>,
                      ellipsis: true,
                      dataIndex: "cutGrade",
                      sorter: (a, b) => {},
                    },

                    {
                      title: (
                        <Tooltip title={t("Clarity")}>{t("Clarity")}</Tooltip>
                      ),
                      ellipsis: true,
                      dataIndex: "clarity",
                      sorter: (a, b) => {},
                    },
                    {
                      title: (
                        <Tooltip title={t("Certificate")}>
                          {t("Certificate")}
                        </Tooltip>
                      ),
                      ellipsis: true,
                      dataIndex: "certificate",
                      sorter: (a, b) => {},
                    },
                    {
                      title: (
                        <Tooltip title={t("Retail Price")}>
                          {t("Retail Price")}
                        </Tooltip>
                      ),
                      ellipsis: true,
                      dataIndex: "retailPrice",
                      sorter: (a, b) => {},
                      render: (retailPrice) => (
                        <Tooltip title={retailPrice}>
                          <span>{retailPrice}</span>
                        </Tooltip>
                      ),
                    },
                    {
                      title: <Tooltip title={t("Cost")}>{t("Cost")}</Tooltip>,
                      ellipsis: true,
                      dataIndex: "cost",
                      sorter: (a, b) => {},
                      render: (cost) => (
                        <Tooltip title={cost}>
                          <span>{cost}</span>
                        </Tooltip>
                      ),
                    },
                  ]}
                  pagination={{
                    size: "small",
                    total: totalCount,
                    pageSizeOptions: [10, 15, 20, 50, 100],
                    responsive: true,
                    showSizeChanger: true,
                    pageSize: pageSize,
                    current: pageNo,
                  }}
                  onChange={handleTableASCDES}
                  loading={showTableLoader}
                  dataSource={JewelryPriceTableList}
                />
              </div>
            </div>
            <Modal
              title=""
              centered
              visible={visible}
              onOk={() => setVisible(false)}
              onCancel={() => setVisible(false)}
              width={500}
              footer={false}
            >
              <div className="">
                <img alt="img" className="img-fluid" />
              </div>
            </Modal>

            <Modal
              title=""
              centered
              visible={defaultVisible}
              onOk={() => setDefaultVisible(false)}
              onCancel={() => setDefaultVisible(false)}
              width={500}
              footer={false}
            >
              <div className="">
                <img src={DefaultImage} alt="img" className="img-fluid" />
              </div>
            </Modal>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DiamondPriceBasedAddToCartReports;